export const RELOAD_TYPES = {
    EVERYTHING: 'everything',
    DATA: 'data',
    ANNOTATIONS: 'annotations',
    MEDIA: 'media',
    OVERRIDES_ONLY: 'overrides_only'
};
export const WRAPPER_TYPES = {
    VIDEO_JS: 'videojs4',
    NO_MEDIA: 'nomedia'
};

export const PLAYER_TYPES = {
    LIVE: 'live'
};

export const ANNOTATION_TARGETS = {
    PLAYER: 'player',
    ADJACENT_LEFT: 'adjacent_left',
    ADJACENT_RIGHT: 'adjacent_right',
    ADJACENT_TOP: 'adjacent_top',
    ADJACENT_BOTTOM: 'adjacent_bottom'
};

export const ANIMATION_DURATION_MS = 125;

export const PLAY_STATES = {
    INDETERMINATE: 'indeterminate',
    PLAYING: 'playing',
    PAUSED: 'paused',
    SEEK_FORWARD: 'seek_forward',
    SEEK_BACKWARD: 'seek_backward'
};

export const MEDIA_CHANGE_STATES = {
    LOADING: 'loading',
    LOADED: 'loaded'
};

export const OVERRIDES_PROVIDER_KEY = '__HAPYAK__OVERRIDES__PROVIDER__';

export const CONDITIONS = {
    EQUAL: 'equal',
    LESS_THAN: 'lessThan',
    GREATER_THAN: 'greaterThan',
    INCLUDES: 'includes',
    NOT_CONDITION: 'notCondition'
};

export const DEVICE_TYPES = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
    TELEVISION: 'television'
};

export const ORIENTATIONS = {
    PORTRAIT: 'portrait',
    LANDSCAPE: 'landscape'
};

export const EMBED_TYPES = {
    IFRAME: 'iframe',
    CUSTOM_ELEMENT: 'customElement'
};

export const NATIVE_EVENT_NAMES = ['onabort','onafterprint','onanimationend','onanimationiteration','onanimationstart','onbeforeprint','onbeforeunload','onblur','oncanplay','oncanplaythrough','onchange','onclick','oncontextmenu','oncopy','oncut','ondblclick','ondrag','ondragend','ondragenter','ondragleave','ondragover','ondragstart','ondrop','ondurationchange','onended','onerror','onfocus','onfocusin','onfocusout','onfullscreenchange','onfullscreenerror','onhashchange','oninput','oninvalid','onkeydown','onkeypress','onkeyup','onload','onloadeddata','onloadedmetadata','onloadstart','onmessage','onmousedown','onmouseenter','onmouseleave','onmousemove','onmouseover','onmouseout','onmouseup','onwheel','onoffline','ononline','onopen','onpagehide','onpageshow','onpaste','onpause','onplay','onplaying','onprogress','onratechange','onresize','onreset','onscroll','onsearch','onseeked','onseeking','onselect','onshow','onstalled','onsubmit','onsuspend','ontimeupdate','ontoggle','ontouchcancel','ontouchend','ontouchmove','ontouchstart','ontransitionend','onunload','onvolumechange','onwaiting','onwheel'];

export const SCORE_OPERATIONS = {
    ADD: '+',
    SUBTRACT: '-',
    ASSIGN: '='
}

export const MAX_STATE_UPDATES_PER_SECOND = 20;

export const STATE_SERIALIZATION_BLACKLIST = [
    'children',
    'bus',
    'bookmarks',
    'currentTime',
    'data',
    'dimensions',
    'key',
    'muted',
    'onClick',
    'startTimes',
    'metadata',
    'parentState',
    'actions',
    '__self',
    '__source',
    'player',
    'onMenuToggle'
]

export const BREAKPOINTS = {
    SMALL_PLAYER_WIDTH: 500
}